// In badimomessage.jsx
export const BadimoMessage = () => {
  // component code
};
